/* jscs:disable maximumLineLength */
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import { getCurrentPath } from '../../core/util/url';
import { isEmptyObject } from '../../core/util/object';
import { isEmptyString } from '../../core/util/string';
import { METRO_URGENT_CARE_FACEBOOK_TRACKING_ID } from '../../config';
import UrgentCareForKidsBingPixel from '../../components/Tracking/UrgentCareForKidsBing';
import MetroUrgentCareFacebook from '../../components/Tracking/MetroUrgentCareFacebook';
import MetroUrgentCareAdWords from '../../components/Tracking/MetroUrgentCareAdWords';
import { isDev } from '../../config/';
import { safeGet } from '../util/object';
export const GA_EVENT = 'event';
export const GA_EVENT_ACTION_BOOKING = 'submit';
export const GA_EVENT_CATEGORY_BOOKING = 'booking';
export const GA_PAGEVIEW = 'pageview';

const fireGaTracking = (trackerId, trackerName, trackingType, opts = {}) => {
  if (trackingType === GA_EVENT && (!opts.eventAction || !opts.eventCategory)) {
    throw new Error('Need to pass both eventAction and eventCategory for event tracking');
  }

  const gaOptions = {
    allowLinker: true,
    alwaysSendReferrer: true,
    cookieDomain: 'auto',
    name: trackerName,
  };

  ReactGA.initialize(trackerId, { gaOptions });

  if (opts.forceSsl) {
    ReactGA.ga(`${trackerName}.set`, 'forceSSL', true);
  }

  ReactGA.ga(`${trackerName}.require`, 'linker');

  if (opts.referringDomain) {
    ReactGA.ga(`${trackerName}.linker:autoLink`, [opts.referringDomain]);
  }

  if (trackingType === GA_PAGEVIEW) {
    ReactGA.ga(`${trackerName}.send`, trackingType, getCurrentPath());
  } else if (trackingType === GA_EVENT) {
    ReactGA.ga(
      `${trackerName}.send`,
      trackingType,
      opts.eventCategory,
      opts.eventAction,
      opts.eventLabel
    );
  }
};

const fireFbTracking = trackerId => {
  ReactPixel.init(trackerId);
  ReactPixel.fbq('track', 'PageView');
  ReactPixel.fbq('track', 'CompleteRegistration');
};

const getAdWordsTrackingProperties = location =>
  safeGet(location)('trackingProperties.google_adwords');

const isConfiguredForAdWordsTracking = location =>
  !isEmptyObject(getAdWordsTrackingProperties(location));

const isConfiguredForGoogleAnalyticsTracking = location =>
  !(
    isEmptyObject(location.trackingProperties) ||
    isEmptyObject(location.trackingProperties.google_analytics)
  );

const fireGoogleAnalytics = (location, eventType = GA_PAGEVIEW, eventAction, eventCategory) => {
  if (isDev()) {
    console.warn('Google Analytics Tracking cannot be fired in dev. exiting.');
    return;
  }

  if (
    isEmptyObject(location.trackingProperties) ||
    isEmptyObject(location.trackingProperties.google_analytics)
  ) {
    console.error(
      `Could not fire tracking! Tracking properties for location ${location.id} are not defined`
    );
    return;
  }

  const trackingProperties = location.trackingProperties.google_analytics;
  const trackingId = trackingProperties.id;
  const trackerName = trackingProperties.tracker_name;
  const referringDomain = trackingProperties.referring_domain;

  if (isEmptyString(trackingId) || isEmptyString(trackerName) || isEmptyString(referringDomain)) {
    console.error(
      'Could not fire tracking! trackingId, trackerName, referringDomain must be ' +
        `defined correctly for location ${location.id} `
    );
    return;
  }

  const forceSsl =
    typeof trackingProperties.force_ssl === 'undefined' ? false : trackingProperties.force_ssl;

  const options = {
    referringDomain,
    forceSsl,
  };

  if (eventType === GA_EVENT) {
    const label = location.id;

    if (isEmptyString(eventAction) || isEmptyString(eventCategory)) {
      console.error(
        'Could not fire tracking! Tracking properties eventAction and eventCategory ' +
          'need to be specified for a GA_EVENT'
      );
      return;
    }

    options.eventAction = eventAction;
    options.eventCategory = eventCategory;
    options.eventLabel = label;
  }

  fireGaTracking(trackingId, trackerName, eventType, options);
};

const fireMetroUrgentCareFacebookTracking = () =>
  fireFbTracking(METRO_URGENT_CARE_FACEBOOK_TRACKING_ID);

const getUrgentCareForKidsBingTrackingPixel = () => UrgentCareForKidsBingPixel();

const getMetroUrgentCareFacebookTrackingPixel = () => MetroUrgentCareFacebook();
const getMetroUrgentCareAdwordsTracking = () => MetroUrgentCareAdWords();

export {
  fireMetroUrgentCareFacebookTracking,
  getUrgentCareForKidsBingTrackingPixel,
  getMetroUrgentCareFacebookTrackingPixel,
  getMetroUrgentCareAdwordsTracking,
  isConfiguredForGoogleAnalyticsTracking,
  isConfiguredForAdWordsTracking,
  getAdWordsTrackingProperties,
  fireGoogleAnalytics,
};
